export const CLIENT_ID = 'paragon' as const;
export const DATABASE_LABEL = 'pmt';

export const COMPETITOR_OPTIONS = [
    { value: 'Berry Plastics', displayText: 'Berry Plastics' },
    { value: 'Interplast Am Topp', displayText: 'Interplast Am Topp' },
    { value: 'Intertape', displayText: 'Intertape' },
    { value: 'ITW / Signode', displayText: 'ITW / Signode' },
    { value: 'Malpack', displayText: 'Malpack' },
    { value: 'Private Label', displayText: 'Private Label' },
    { value: 'Sigma', displayText: 'Sigma' },
    { value: 'ValFilm', displayText: 'ValFilm' },
    { value: 'Zummit', displayText: 'Zummit' },
    { value: 'Alliance Plastics', displayText: 'Alliance Plastics' },
    { value: 'Scientex', displayText: 'Scientex' },
    { value: 'Revolution', displayText: 'Revolution' },
    { value: 'Other', displayText: 'Other' },
    { value: '', displayText: '<blank>' },
];

export const DEFAULT_EXPORT_FREIGHT_TEXT =
    'FOB Destination anywhere in the continental US, 2 Pallets Machine Film, 5 Pallets Hand Film (or Machine/Hand Combo with exception of Titus), and 10 Pallets Minimum order quantity on Titus';
export const DEFAULT_EXPORT_LEAD_TIME_TEXT =
    'Standard = 28 Calendar Days + Transit on Nexus Films, 35 on Titus Films, and 35 on Cold Force in Calendar Days + Transit days to Destination.';
export const DEFAULT_EXPORT_PCR_PRICE_CHANGES = `Price changes for PCR products are made at least quarterly and are not tied to a specific resin index. Paragon reserves the right to adjust pricing more frequently for substantial changes in PCR component costs. Customers will be given 15 days advanced notice of a price change and price changes will be made on the 15th of the month. Contact your sales rep for more details.`;
export const DEFAULT_MINIMUM_ORDER_QUANTITY_TEXT =
    '2 pallets machine film, 5 pallets hand film, OR a combination of hand and machine film totaling 5 pallets. Titus is the exception and requires a minimum order of 10 pallets.'

export enum MarketPriceExportEnum {
    EXPORTQUOTE = 'Export Quote (.pdf)',
    EXPORTPRICES = 'Export Prices (.xls)',
}

export enum ModifyPriceMassActionEnum {
    ADDPERCENTAGE = 'Change by Percent',
    ADDAMOUNT = 'Change by Cents',
    SETVALUE = 'Set value',
    RESETTOCURRENTTIER = 'Reset to Current Tier',
}
export enum ApprovalsMassActionEnum {
    APPROVE = 'Approve price changes',
    REJECT = 'Reject price changes',
}

export enum DeviationDateMassActionEnum {
    ENDDATES = 'Change deviation end date',
}

export enum ActivePriceDeviationDateMassActionEnum {
    ENDDATES = 'Change active price deviation end date',
}

export enum ActivePriceCopyMarketPricesToDistributorMassActionEnum {
    COPY = 'Copy Market Prices To Distributor',
}

export enum ActivePriceMarketPriceDeleteMassActionEnum {
    DELETE = 'Mass delete active price market prices',
}

export enum ManagePricingMarketPriceDeleteMassActionEnum {
    DELETE = 'Mass delete market prices',
}

export enum ApproverEnum {
    NOTREQUIRED = 'Not Required',
    NOTAVAILABLE = 'Not Available',
}

export enum ApprovalStatusEnum {
    APPROVED = 'Approved',
    NEEDSAPPROVAL = 'Needs Approval',
    REJECTED = 'Rejected',
}

export enum ApprovalLevelRequirementEnum {
    LEVEL1 = 1,
    LEVEL2 = 2,
    NOTREQUIRED = 0,
}

export enum ProductFilterEnum {
    CATALOG = 'Catalog',
    EXCLUSIVE = 'Exclusive',
    PRIVATE = 'Private',
}

export const FILM_TYPES = [
    { value: 'Handheld', displayText: 'Handheld' },
    { value: 'Machine', displayText: 'Machine' },
    { value: 'Torque', displayText: 'Torque' },
    { value: 'pcr', displayText: 'PCR' },
];
